import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { throwException } from "../../../actions/exceptionActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import { getSettings } from "../../../store/configureStore";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";

class DeprecatedStartPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, false);
    }

    render() {
            const settings = getSettings();
            return (
                <Section>
                    <Fieldset>
                        <div className="jumbotron">
                            <h1>Via deze weg heb je niet langer toegang.</h1>
                            <br />
                            Als medewerker van een sportfederatie-koepelorganisatie / gemeente moet je aanmelden via het <a href={settings.eloketUrl} target="blank" style={{ "color": "#006fb7" }}>E-loket van Sport Vlaanderen</a>.
                        </div>
                    </Fieldset>
                </Section>
            );
        }
}

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeprecatedStartPage);